import React from 'react'
import PropTypes from 'prop-types'
import Avatar from '@material-ui/core/Avatar'
import Link from '@material-ui/core/Link'
import Typography from '@material-ui/core/Typography'
import { PGA_COM_HOST } from 'env'
import useStyles from './styles'

const HostHeader = ({ coach }) => {
  const classes = useStyles()
  const { coachProfile } = coach
  const displayName = coachProfile?.displayName ?? coach.name

  return (
    <div className={classes.chatHeader}>
      <div className={classes.host}>
        <Avatar
          className={classes.hostAvatar}
          src={coachProfile?.profilePhoto || ''}
          alt="coach"
        >
          {displayName.substring(0, 1)}
        </Avatar>
        <div>
          <Typography variant="h6" component="p" className={classes.hostName}>
            {displayName}
          </Typography>
          <span className={classes.hostRole}>Event Host</span>
        </div>
      </div>
      {coachProfile != null && (
        <Link
          className={classes.profileLink}
          href={`${PGA_COM_HOST}/coach/${coachProfile.customSlug}`}
        >
          View Profile
        </Link>
      )}
    </div>
  )
}

HostHeader.propTypes = {
  coach: PropTypes.shape({
    name: PropTypes.string,
    coachProfile: PropTypes.shape({
      displayName: PropTypes.string,
      profilePhoto: PropTypes.string,
      customSlug: PropTypes.string,
    }),
  }).isRequired,
}

export default HostHeader
